import React, { useState } from "react";
import { useQuery, gql } from "@apollo/client";
import {
    AppBar,
    Box,
    CircularProgress,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
    Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import {GET_PROJECTS} from "../graphql/query";

const ProjectInput = ({ value, onChange }) => {
    const [selectedIndex, setSelectedIndex] = useState(value ? value.id : null); // Храним id выбранной группы
    const { loading, error, data } = useQuery(GET_PROJECTS);
    const navigate = useNavigate(); // Для навигации

    const handleListItemClick = (project) => {
        setSelectedIndex(project.id); // Устанавливаем выбранную группу
        if (onChange) {
            onChange(project); // Передаем выбранную группу родительскому компоненту
        }
    };

    const handleSave = () => {
        if (onChange) onChange(data.projects.find((grp) => grp.id === selectedIndex));
        navigate(-1); // Навигация назад
    };

    const handleBack = () => {
        navigate(-1); // Навигация назад
    };

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <Typography color="error">Ошибка загрузки проектов: {error.message}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            {/* Верхняя панель */}
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Выберите проект
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Список проектов */}
            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                <List component="nav" aria-label="projects">
                    {data.projects.map((project) => (
                        <ListItemButton
                            key={project.id}
                            selected={selectedIndex === project.id} // Подсвечиваем выбранный элемент
                            onClick={() => handleListItemClick(project)}
                        >
                            <ListItemText primary={project.name} />
                        </ListItemButton>
                    ))}
                </List>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={handleSave}
                    disabled={!selectedIndex} // Кнопка неактивна, если ничего не выбрано
                >
                    Сохранить
                </Button>
            </Box>
        </Box>
    );
};

export default ProjectInput;
